import { render, staticRenderFns } from "./ActivationTab.vue?vue&type=template&id=c51a3840&scoped=true"
import script from "./ActivationTab.vue?vue&type=script&lang=js"
export * from "./ActivationTab.vue?vue&type=script&lang=js"
import style0 from "./ActivationTab.vue?vue&type=style&index=0&id=c51a3840&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c51a3840",
  null
  
)

export default component.exports